module.exports = __webpack_public_path__ + "static/media/fidweb-fantastico_optimized.b361f40c.png";